import { ref, watch, type Ref } from 'vue';

// A cache for instant display, not a source of truth — callers must re-validate.
export function persistedRef<T>(storage: Storage, key: string, defaultValue: T): Ref<T> {
  const stored = storage.getItem(key);
  let initial = defaultValue;
  if (stored !== null) {
    try {
      initial = JSON.parse(stored) as T;
    } catch {
      initial = defaultValue;
    }
  }

  const value = ref(initial) as Ref<T>;

  watch(
    value,
    (newValue) => {
      if (newValue === undefined) {
        storage.removeItem(key);
      } else {
        storage.setItem(key, JSON.stringify(newValue));
      }
    },
    { deep: true }
  );

  return value;
}
